// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { RiderFeedbackAreaId } from './RiderFeedbackAreaId'
import { RiderFeedbackAreaNavigation } from './RiderFeedbackAreaNavigation'
import { RiderFeedbackAreaRoutes } from './RiderFeedbackAreaRoutes'

const LazyRiderFeedbackComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./RiderFeedbackArea')),
)

const RiderFeedbackComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRiderFeedbackComponent />
  </SuspenseLoadingWrapper>
)

export const RiderFeedbackArea = {
  id: RiderFeedbackAreaId,
  requiredRight: BoumRight.AREA_RIDER_FEEDBACK,
  NavigationComponent: RiderFeedbackAreaNavigation,
  route: {
    path: RiderFeedbackAreaRoutes.route,
    component: RiderFeedbackComponent,
  },
}
